import React, { useCallback, useEffect, useMemo } from "react";
import { unified } from "unified";
import remarkParse from "remark-parse";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";
import remarkRehype from "remark-rehype";
// import rehypeRaw from "rehype-raw"; // enable only for trusted raw HTML
import rehypeKatex from "rehype-katex";
import rehypePrism from "rehype-prism";
import rehypeReact from "rehype-react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { jsxDEV as _jsxDEV } from "react/jsx-dev-runtime";
import Prism from "prismjs";

import "katex/dist/katex.min.css";
import "prismjs/themes/prism.css";
import "prismjs/components/prism-python.min.js";

function Markdown({ text = "", textOnlyMode = false }) {
  const isDev = process.env.NODE_ENV !== "production";

  const rendered = useMemo(() => {
    const u = unified()
      .use(remarkParse)
      .use(remarkGfm)
      .use(remarkMath)
      .use(remarkRehype, { allowDangerousHtml: true })
      // .use(rehypeRaw) // only if you trust the HTML in the markdown
      .use(rehypeKatex, {
        output: "htmlAndMathml",
        throwOnError: false,
        strict: false,
      })
      .use(rehypePrism);

    if (isDev) {
      u.use(rehypeReact, { Fragment, jsxDEV: _jsxDEV, development: true });
    } else {
      u.use(rehypeReact, { Fragment, jsx, jsxs });
    }

    return u.processSync(text).result;
  }, [text, isDev]);

  useEffect(() => {
    Prism.highlightAll();
  }, [rendered]);

  const handleCopy = useCallback((event) => {
    event.preventDefault();
    const selection = window.getSelection()?.toString() ?? "";
    event.clipboardData.setData("text/plain", selection);
    const htmlContent = `<p><strong>Copied from Markdown Component:</strong></p><pre>${selection}</pre>`;
    event.clipboardData.setData("text/html", htmlContent);
  }, []);

  if (textOnlyMode) return <>{text}</>;

  return <div className="markdownView" onCopy={handleCopy}>{rendered}</div>;
}

export default Markdown;